<template>
  <form v-on:submit="save">
    <div class="card card-info" id="app">
      <div class="card-header with-border">
        <h3 class="card-title">Department Coordinator</h3>
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <div class=" form-horizontal" style="padding-left: 2%; padding-right: 2%; padding-top: 1%;">
        <div class="row">
          <div class="col-md-6">
            <label>Program</label>
            <select class="form-control form-control-sm" v-model="master.ProgramID" v-on:change="loadSessions()" required>
              <option value="0">--Select Program--</option>
              <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label>Session</label>
            <select class="form-control form-control-sm" v-model="master.SessionID" v-on:change="sectionChange()" required>
              <option value="0">--Select Session--</option>
              <option v-for="item in sessions" v-bind:value="item.RoadMapID">{{item.SessionName}}</option>
            </select>
          </div>
        </div>
        <div class="row" style="margin-top: 8px;">
          <div class="col-md-12">
            <br />
            <div class="table-responsive">
              <table class="table table-bordered table-sm table-color">
                <thead class="bg-info">
                  <tr>
                    <th>Sr.#</th>
                    <th style="width: 15%">Code</th>
                    <th style="width: 25%">Name</th>
                    <th style="width: 50%">Pre-Requisite</th>
                    <th style="width: 10%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in child">
                    <td style="vertical-align: middle;">
                      {{index + 1}}
                    </td>
                    <td>
                      {{item.CourseCode}}
                    </td>
                    <td>
                      {{item.CourseName}}
                    </td>
                    <td>
                      <span v-for="(p, ind) in item.PreReq">
                        {{p.CourseName}}<span v-show="ind != item.PreReq.length - 1 && item.PreReq.length > 1">, </span>
                      </span>
                    </td>
                    <td style="text-align: center;">
                      <button v-on:click="edit(index)" type="button" style="background-color: transparent; border: none;"><i class="fa fa-2x fa-edit"></i></button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="5">
                      <button class="btn btn-dark" type="button" v-on:click="showPopup()" style="width: 100%"><i class="fa fa-plus" style="margin-right: 2px;"></i>Add New</button>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

          </div>
        </div>
      </div>
      <hr />
      <!--Button -->
      <div class="card-footer">
        <input type="submit" value="Save" class="btn btn-success float-right" v-show="isupdate == false" />
        <!--<button class="btn btn-success" type="button" v-show="isupdate == false" v-on:click="save()">Save</button>-->
        <button class="btn btn-success float-right" v-show="isupdate == true" type="button" v-on:click="update()">Update</button>
        <button type="button" class="btn btn-danger" v-on:click="cancel()">Cancel</button>
      </div>
      <!-- Modal -->
      <div id="peomodal" class="modal fade" role="dialog">
        <div class="modal-dialog modal-lg">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Course Pre-Requisite</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <label>Course</label>
                  <select class="form-control" v-model="data.courseid">
                    <option value="0">--Select Course--</option>
                    <option v-for="item in courses" v-bind:value="item.CourseID">{{item.CourseName}}</option>
                  </select>
                </div>
                <div class="col-md-12">
                  <label>Pre-Requisite Course</label>
                  <v-select v-model="altemp" transition="" v-bind:multiple="true" v-bind:options="courses" label="CourseName" id="ddlPCrs" style="max-width: 100%;"></v-select>
                  <!--<select class="form-control select2" multiple="multiple" id="ddlPCrs" style="width: 100%">
                    <option v-for="item in courses" v-bind:value="item.CourseID">
                      {{item.CourseName}}
                    </option>
                  </select>-->
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" v-show="ind == -1" v-on:click="addNew()">Add</button>
              <button type="button" class="btn btn-success" v-show="ind != -1" v-on:click="updateChild()">Update</button>
              <button type="button" class="btn btn-danger" v-show="ind != -1" v-on:click="remove()">Delete</button>
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        isupdate: false,
        master: { ProgramID: 0, SessionID: 0 },
        departments: [],
        programs: [],
        sessions: [],
        seldept: 0,
        altemp: null,
        child: [],
        courses: [],
        data: { ode: '', name: '', pre: '' },
        ind: -1
      }
    },
    created: function () {
      this.loadPrograms();
    },
    methods: {
      loadPrograms() {
        startReq();
        var vm = this;
        axios.post('/api/DCApi/loadProgramDepartmentWise')
          .then(function (res) {
            endReq();
            vm.programs = res.data['program'];
          })
          .catch(function (res) {
            endReq();
          });
      },

      loadSessions() {
        startReq();
        var vm = this;
        axios.post('/api/DCApi/loadRoadMapSession?ID=' + vm.master.ProgramID)
          .then(function (res) {
            endReq();
            vm.sessions = res.data.lst;
          })
          .catch(function (res) {
            endReq();
          });
      },

      sectionChange() {
        startReq();
        var vm = this;
        axios.post('/api/DCApi/loadRoadMapCourse?ID=' + vm.master.SessionID)
          .then(function (res) {
            endReq();
            vm.courses = res.data.crs;
            vm.child = res.data.rec;
            if (vm.child.length != 0) {
              vm.isupdate = true;
            }
            else {
              vm.isupdate = false;
            }
          })
          .catch(function (res) {
            endReq();
          });
      },

      save(e) {
        e.preventDefault();
        if (this.child.length == 0) {
          toastr.error("Please Add min one subject");
          return;
        }
        startReq();
        var vm = this;
        axios.post('/api/DCApi/saveCoursePreReq', {
          obj: vm.child
        })
          .then(function (res) {

            if (!res.data.status) {
              for (var i = 0; i < !res.data.status.length; i++) {
                toastr.error(rs['error'][i], "Error!");
              }
            }
            else {
              toastr.success("Saved Successfully", "Done!");
              vm.clear();
            }
            endReq();
          })
          .catch(function (res) {
            endReq();
          });
      },

      update() {
        if (this.child.length == 0) {
          toastr.error("Please Add min one subject");
          return;
        }
        startReq();
        var vm = this;
        axios.post('/api/DCApi/updateCoursePreReq', {
          obj: vm.child
        })
          .then(function (res) {
            if (!res.data.status) {
              for (var i = 0; i < !res.data.status.length; i++) {
                toastr.error(rs['error'][i], "Error!");
              }
            }
            else {
              toastr.success("Saved Successfully", "Done!");
              vm.clear();
            }
            endReq();
          })
          .catch(function (res) {
            endReq();
          });
      },


      cancel() {
        location.reload();
      },
      lock() {
        startReq();
        var vm = this;
        axios.post('/api/DCApi/lockPEO', {
          peo: vm.peo,
        })
          .then(function (res) {
            if (!res.data.status) {
              for (var i = 0; i < !res.data.status.length; i++) {
                toastr.error(rs['error'][i], "Error!");
              }
            }
            else {
              toastr.success("Locked Successfully", "Done!");
              vm.clear();
            }
            endReq();
          })
          .catch(function (res) {
            endReq();
          });
      },

      clear() {
        this.isupdate = false;
        this.master.ProgramID = 0;
        this.master.SessionID = 0;
        this.seldept = 0;
        this.child = [];
      },

      //Modal
      showPopup() {
        this.ind = -1;
        $('#peomodal').modal('show');
        this.clearModal();
      },

      addNew() {
        if (this.checkModal()) {
          if (this.child.find(x => x.CourseID == this.data.courseid) != null) {
            toastr.error("course already added");
            return;
          }
          var crs = this.courses.find(x => x.CourseID == this.data.courseid);
          this.child.push({ RoadMapMasterID: this.master.SessionID, CourseID: crs.CourseID, CourseCode: crs.CourseCode, CourseName: crs.CourseName, PreReq: this.altemp });
          $('#peomodal').modal('hide');
          this.clearModal();
        }
      },

      edit(index) {
        this.clearModal();
        this.ind = index;
        $('#peomodal').modal('show');
        var obj = this.child[index];
        this.data.courseid = obj.CourseID;
        this.altemp = obj.PreReq;
        var temp = [];
        for (var i = 0; i < obj.PreReq.length; i++) {
          temp.push(obj.PreReq[i].CourseID)
        }
        console.log(temp);
        $('#ddlPCrs').val(temp);
        $('#ddlPCrs').trigger('change');
      },

      updateChild() {
        if (this.checkModal()) {
          var crs = this.courses.find(x => x.CourseID == this.data.courseid);
          this.child.splice(this.ind, 1, { RoadMapMasterID: this.master.SessionID, CourseID: crs.CourseID, CourseCode: crs.CourseCode, CourseName: crs.CourseName, PreReq: this.altemp });
          this.altemp = [];
          $('#peomodal').modal('hide');
          this.clearModal();
          this.ind = -1;
        }
      },

      checkModal() {
        var error = false;
        if (this.data.courseid == '') {
          toastr.error("No course selected", "Error");
          error = true;
        }
        if (this.altemp.length == 0) {
          toastr.error("Pre-Requisites required", "Error");
          error = true;
        }

        if (error == true) {
          return false
        }
        else {
          return true;
        }
      },

      clearModal() {
        this.data = { CourseID: '', name: '', description: '' }
        this.altemp = [];
        $('#ddlPCrs').val(this.altemp);
        $('#ddlPCrs').trigger('change');
      },

      remove() {
        this.child.splice(this.ind, 1);
        $('#peomodal').modal('hide');
        this.clearModal();
      },
    }
  })
</script>




// WEBPACK FOOTER //
// src/components/DC/coursePreRequisite.vue